import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class ProjectsPath extends BaseRouteConfig {
  public readonly Index = 'projects';

  public readonly List = {
    Path: `${this.Path}/list`,
    All: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/all`),
    Owned: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/owned`),
    Others: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/others`),
  };

  public readonly Details = {
    Path: `${this.Path}/:projectId`,
    Paths: new ACDLRoute<{ workspaceId: string; projectId: string; tab: string }>(`${this.Path}/:projectId/:tab`),
    Overview: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/overview`),
    Datasets: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/datasets`),
    Images: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/images`),
    TeamMembers: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/members`),
    Statistics: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/statistics`),
    NewStatistics: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/new-statistics`),
    ExportData: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/export-data`),
    AnnotationView: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/annotation-view`),
    ActivityLog: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/activity-log`),
    Preview: new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId?/preview`),
  };
}
